// extracted by css-extract-rspack-plugin
export default {"Flash":"InvalidCitationWarning-module__Flash__TFzHv"};